import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../utils/store';

export interface DeleteVehicleModalState {
    isOpen: boolean;
    vehicleId: string;
}

const initialState: DeleteVehicleModalState = {
    isOpen: false,
    vehicleId: '',
};

export const slice = createSlice({
    name: 'deleteVehicleModal',
    initialState,
    reducers: {
        setOpen: (state, action: PayloadAction<boolean>) => {
            state.isOpen = action.payload;
        },
        setVehicleId: (state, action: PayloadAction<string>) => {
            state.vehicleId = action.payload;
        },
    },
});

export const { setOpen, setVehicleId } = slice.actions;
export const actions = slice.actions;

export const selectIsOpen = (state: RootState) =>
    state.deleteVehicleModal.isOpen;
export const selectVehicleId = (state: RootState) =>
    state.deleteVehicleModal.vehicleId;

export default slice.reducer;
